import { render, staticRenderFns } from "./EmailLinkDialog.vue?vue&type=template&id=2b5fd854&"
import script from "./EmailLinkDialog.vue?vue&type=script&lang=js&"
export * from "./EmailLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports